export var pdfWrap = function pdfWrap(theme) {
  return {
    marginBottom: '2em',
    border: "10px solid ".concat(theme.gray100)
  };
};
export var signLabel = {
  marginBottom: '0.5em'
};
export var signWrap = function signWrap(theme) {
  return {
    '& .sigCanvas': {
      marginBottom: '2em',
      border: "10px solid ".concat(theme.gray100),
      width: '100%',
      height: 300
    }
  };
};